import { addContext, removeContext, setContext, } from '../../features/dictionary-field-context/dictionary-field-context-actions.js';
import { dictionaryFieldContextReducer as dictionaryFieldContext } from '../../features/dictionary-field-context/dictionary-field-context-slice.js';
import { loadReducerError } from '../../utils/errors.js';
import { buildController, } from '../controller/headless-controller.js';
/**
 * Creates a `DictionaryFieldContext` controller instance.
 *
 * @param engine - The headless engine.
 * @returns A `DictionaryFieldContext` controller instance.
 *
 * @group Controllers
 * @category DictionaryFieldContext
 */
export function buildDictionaryFieldContext(engine) {
    if (!loadReducers(engine)) {
        throw loadReducerError;
    }
    const controller = buildController(engine);
    const { dispatch } = engine;
    const getState = () => engine.state;
    return {
        ...controller,
        get state() {
            return {
                values: getState().dictionaryFieldContext.contextValues,
            };
        },
        set(context) {
            dispatch(setContext(context));
        },
        add(field, key) {
            dispatch(addContext({ field, key }));
        },
        remove(field) {
            dispatch(removeContext(field));
        },
    };
}
function loadReducers(engine) {
    engine.addReducers({ dictionaryFieldContext });
    return true;
}
